<template lang="pug">
  include ./../../../mixins
  div.get-form
    .loading-mask(v-show="isLoading")
      .custom-loader
    validation-observer(
      ref="observer",
      tag="form",
      class="form",
      @submit.prevent="submit"
    )
      +b.el--p_t_lg-md
        +b.g-row--space_xl.--align_end.rel
          +b.g-cols--12
            vue-recaptcha(
              ref="recaptcha"
              size="invisible"
              :sitekey="sitekey"
              @verify="submit"
              @expired="onCaptchaExpired"
            )
          +b.g-cols--12.--4-md.g-cell.el--m_t_1sm.--m_t_none-md
            +b.ds-caption--size_xs.--c_black.--w_r {{trans.name}}
            +b.el--p_t_1xs.rel
              input-group.effect-1(
                rules='required|text'
                type="text",
                name="name"
                v-model="formData.name"
                :placeholder="trans.name_place"
              )
                template(v-slot:error="{errors}")
                  transition(name="fade")
                    span.help--type_error(v-if='errors.length') {{ trans.phone_name }}
          +b.g-cols--12.--4-md.g-cell.el--m_t_2xs.--m_t_none-md
            +b.ds-caption--size_xs.--c_black.--w_r {{trans.phone}}
            +b.el--p_t_1xs.rel
              input-group(
                rules='required|phones|min:9|max:16'
                type="tel",
                name="phone"
                v-model="formData.phone"
                :placeholder="trans.phone_place"
              )
                template(v-slot:error="{errors}")
                  transition(name="fade")
                    span.help--type_error(v-if='errors.length') {{ trans.phone_valid }}
          +b.g-cols--12.--4-md.el--m_t_1sm.--m_t_none-md
            +b.btn.--max.--blue.--br.br-none(@click="validate")
              +b.g-row.g-cell
                +b.P.ds-caption--size_md.--c_white.--w_b {{trans.submit_phone}}
</template>

<script>

import VueRecaptcha from 'vue-recaptcha'
import { submit, openModal, resetForm } from './utils'
import FormRequest from '../services/forms'

export default {
  components: { VueRecaptcha },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        captcha: '',
        title: this.titleFrom,
      },
      isLoading: false,
      sitekey: window.captcha,
      error: window.error,
    }
  },
  props: {
    titleFrom: String,
  },
  methods: {
    validate() {
      this.$refs.recaptcha.execute()
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    async submit(recaptchaToken) {
      const isValid = await submit(this.$refs.observer)
      this.formData.captcha = recaptchaToken
      if (isValid) {
        this.isLoading = true
        FormRequest.getPhone(this.formData)
          .then(({ data }) => {
            this.isLoading = false
            openModal(this, data.data)
            this.onCaptchaExpired()
            this.formData = resetForm(this.formData)
            requestAnimationFrame(() => {
              this.$refs.observer.reset()
            })
            this.$nextTick(() => {
              this.$emit('close')
            })
          })
        // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.isLoading = true
            openModal(this, this.error.data)
            this.isLoading = false
          })
        // eslint-disable-next-line no-empty
      } else {

      }
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/js/components/app/Forms/GetPhoneForm.vue